import { render, staticRenderFns } from "./patentDetails.vue?vue&type=template&id=1a2c7521&scoped=true&"
import script from "./patentDetails.vue?vue&type=script&lang=js&"
export * from "./patentDetails.vue?vue&type=script&lang=js&"
import style0 from "./patentDetails.vue?vue&type=style&index=0&id=1a2c7521&prod&scoped=true&lang=scss&"
import style1 from "./patentDetails.vue?vue&type=style&index=1&id=1a2c7521&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2c7521",
  null
  
)

export default component.exports